import axios from "axios";

export const updateBooking = async (bookingId: string, data: any) =>
  await axios.patch(`/booking/${bookingId}`, data);

export const makeDoneBooking = async (bookingId: string, data: any) =>
  await axios.post(`/booking/makeDone/${bookingId}`, data);

export const approveBooking = async (uid: string) =>
  await await axios.patch(`/booking/approve/${uid}`, { uid });

export const denyBooking = async (uid: string) =>
  await axios.patch(`/booking/deny/${uid}`, { uid });

export const getBookingWithDoctorId = async (doctorId: string) =>
  await axios.get(`/booking/doctorId/${doctorId}`);

